let inject = [
  '$scope',
  'SharedService',
  'HomeService',
  '$state',
  '$rootScope',
  '$window',
  '$timeout'
];

class HomeController {
  constructor($scope, SharedService,HomeService, $state, $rootScope, $timeout, $window) {
    this.$state = $state;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
    this.HomeService = HomeService;
    this.pageName = "B2B-PAG-1";

    this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
        this.cmsData = response;
    });
    
  }

  $onInit() {
  }



}

HomeController.$inject = inject;

export default HomeController;




/** WEBPACK FOOTER **
 ** ./www/components/home/home.controller.js
 **/